import {
	performCmdbDeleteRequest,
	performCmdbPostRequest,
	performCmdbPutRequest,
} from '@atlassian/jira-servicedesk-cmdb-client/src/fetch.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	getCmdbAvatarCreateTmpFilesUrl,
	getCmdbAvatarDeleteUrl,
	getCmdbAvatarUploadUrl,
} from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/avatar.tsx';
import { getCmdbObjectByIdAvatarUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/object.tsx';
import type {
	CmdbObjectTypeId,
	CmdbObjectId,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import type {
	CreateTempAvatarResponse,
	AvatarUploadResponse,
	AttachObjectAvatarResponse,
} from './types.tsx';

type AvatarService = {
	uploadAvatar: (arg1: { workspaceId: string; body: FormData }) => Promise<AvatarUploadResponse>;
	attachObjectAvatar: (arg1: {
		workspaceId: string;
		objectId: string;
		avatarUUID: string;
	}) => Promise<AttachObjectAvatarResponse>;
	detachObjectAvatar: (arg1: { workspaceId: string; objectId: CmdbObjectId }) => Promise<void>;
	createTempObjectAvatar: (arg1: {
		workspaceId: string;
		objectKey: string;
	}) => Promise<CreateTempAvatarResponse>;
	deleteObjectAvatar: (arg1: {
		workspaceId: string;
		avatarUUID: string;
		objectTypeId: CmdbObjectTypeId;
	}) => Promise<void>;
};

export const ObjectAvatarService: AvatarService = {
	// The default headers apply `Content-Type': 'application/json' which is not appropriate for file upload
	// We cannot simultaneously set the X-Request-Source header and clear the headers
	// So we call the generic performPostRequest function with an empty headers object
	uploadAvatar: ({ workspaceId, body }) =>
		performPostRequest(getCmdbAvatarUploadUrl(workspaceId), {
			headers: {},
			body,
		}),

	attachObjectAvatar: ({ workspaceId, objectId, avatarUUID }) =>
		performCmdbPutRequest(getCmdbObjectByIdAvatarUrl(workspaceId, objectId), {
			body: JSON.stringify({ avatarUUID }),
		}),

	detachObjectAvatar: ({ workspaceId, objectId }) =>
		performCmdbDeleteRequest(getCmdbObjectByIdAvatarUrl(workspaceId, objectId)),

	createTempObjectAvatar: ({ workspaceId, objectKey }) =>
		performCmdbPostRequest(getCmdbAvatarCreateTmpFilesUrl(workspaceId), {
			body: JSON.stringify({ objectKey }),
		}),

	deleteObjectAvatar: ({ workspaceId, avatarUUID, objectTypeId }) =>
		performCmdbDeleteRequest(getCmdbAvatarDeleteUrl(workspaceId, avatarUUID, { objectTypeId })),
};
